<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: 下拉树
-->
<template>
  <div class="lc-select-tree">
    <el-select
      v-model="selectValue"
      popper-class="lc-select-tree__popper"
      :multiple="multiple"
      :clearable="clearable"
      :filterable="filterable"
      :filter-method="handleFilterSelect"
      :placeholder="placeholder"
      @clear="handleClear"
    >
      <template slot="empty">
        <el-tree
          ref="tree"
          class="lc-select-tree__tree"
          :data="treeData"
          :show-checkbox="multiple"
          :node-key="valueKey"
          :check-strictly="reCheckStrictly"
          :default-checked-keys="defaultCheckedKeys"
          :props="{
            label: labelKey,
            children: childrenKey
          }"
          :filter-node-method="handleFilterNode"
          @check="handleCheck"
          @check-change="handleCheckChange"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </template>
    </el-select>
  </div>
</template>
<script>
import { request } from '@/apis/request';
export default {
  props: {
    // 多选value为数组，单选value为String或Number
    value: {
      type: [Array, String, Number],
      default: () => []
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    childrenKey: {
      type: String,
      default: 'children'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 是否可清空
    clearable: {
      type: Boolean,
      default: false
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: true
    },
    // 是否可筛选
    filterable: {
      type: Boolean,
      default: false
    },
    // 是否严格的遵循父子不互相关联的做法
    checkStrictly: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    // 导出的url
    action: {
      type: String,
      default: ''
    },
    // 导出url请求类型
    method: {
      type: String,
      default: 'GET'
    },
    // 导出的请求头部
    headers: {
      type: Object,
      default: () => ({})
    },
    // 导出附带的额外参数
    data: {
      type: Object,
      default: () => ({})
    },
    // 设置导出请求的返回数据类型
    responseType: {
      type: String,
      default: 'APPLICATION/JSON'
    },
    responseDataName: {
      type: String,
      default: 'data'
    }
  },
  data() {
    return {
      selectValue: null,
      treeData: [],
      defaultCheckedKeys: []
    };
  },
  computed: {
    // 单选需完全遵守父子不关联，多选则均可
    reCheckStrictly() {
      return this.multiple ? this.checkStrictly : true;
    }
  },
  created() {
    this.setTreeValue();
    this.initData();
  },
  mounted() {
    this.setSelectValue();
  },
  methods: {
    initData() {
      if (this.action) {
        this.getTreeData();
      } else {
        this.treeData = this.options;
      }
    },
    // 回显树的选中值
    setTreeValue() {
      if (Array.isArray(this.value)) {
        this.defaultCheckedKeys = this.value || [];
      } else if (typeof this.value === 'string' || typeof this.value === 'number') {
        this.defaultCheckedKeys = this.value ? [this.value] : [];
      }
    },
    getTreeData() {
      request({
        url: this.action,
        method: this.method,
        headers: this.headers,
        params: this.data,
        data: this.data,
        responseType: this.responseType
      }).then(res => {
        this.treeData = res[this.responseDataName];
      });
    },
    // 回显下拉框的值
    setSelectValue() {
      if (this.defaultCheckedKeys?.length) {
        let num = 5; // 最多循环5次
        const interval = setInterval(() => {
          const selectedList = this.$refs.tree.getCheckedNodes();
          if (selectedList?.length) {
            this.selectValue = selectedList.map(item => item[this.labelKey]);
            clearInterval(interval);
          } else {
            num--;
          }
          if (num <= 0) clearInterval(interval);
        }, 500);
      }
    },
    handleCheck(data, { checkedNodes }) {
      const selectedList = checkedNodes;
      const val = selectedList.map(item => item[this.valueKey]);
      this.selectValue = selectedList.map(item => item[this.labelKey]);
      this.$emit('input', val);
      this.$emit('change', selectedList);
    },
    handleNodeClick(data, node) {
      if (!this.multiple) {
        this.selectValue = data[this.labelKey]
        this.$emit('input', data[this.valueKey]);
        this.$emit('change', data);
      }
    },
    handleCheckChange(data, isChecked) {
      // 单选需清空其他选项
      if (!this.multiple && isChecked) {
        this.$refs.tree.setCheckedKeys([data[this.valueKey]]);
      }
    },
    handleClear() {
      this.$refs.tree.setCheckedKeys([]);
    },
    handleFilterSelect(val) {
      this.$refs.tree.filter(val);
    },
    handleFilterNode(value, data, node) {
      if (data[this.labelKey].indexOf(value) > -1) {
        return node;
      }
    }
  }
};
</script>
<style lang="scss">
.lc-select-tree {
  &__popper {
    padding: 10px 0;
    max-height: 280px;
    overflow: auto;
  }
}
</style>
